import { CheckboxFilterTree } from "@jana-technology/platform-ui";

import { LoadingSpinner } from "components/loaders";
import { useGlobalFiltersContext } from "contexts/filters";
import { HierarchyIdToaster } from "./HierarchyIdToaster";

export const OverviewAssetSelection = () => {
  const {
    updateHierarchyIds,
    selectedHierarchyIds,
    setSelectedHierarchyIds,
    hierarchyCheckboxItems,
    assetSelectionQueryResult,
  } = useGlobalFiltersContext();

  const hierarchyIdsKeys = Object.keys(selectedHierarchyIds);
  const submitDisabled = hierarchyIdsKeys.every(
    (key) => selectedHierarchyIds[key] === false,
  );

  return (
    <HierarchyIdToaster
      selectedHierarchyIdsLength={hierarchyIdsKeys.length}
      submitDisabled={submitDisabled}
    >
      <section>
        <div className="h3 text-sm uppercase text-grey-700">
          Asset Selection
        </div>
        <div className="mt-6">
          <LoadingSpinner
            loading={assetSelectionQueryResult.loading}
            className="h-[79px] w-[280px]"
          >
            {hierarchyIdsKeys.length > 0 && (
              <CheckboxFilterTree
                onCheckedChange={setSelectedHierarchyIds}
                checkedState={selectedHierarchyIds}
                submitDisabled={submitDisabled}
                submitButtonOnClick={() => {
                  updateHierarchyIds(selectedHierarchyIds);
                }}
                buttonText="Apply Asset Selection"
                fullFilterTree={hierarchyCheckboxItems}
                filters={hierarchyCheckboxItems}
                defaultExpandedValues={Object.keys(selectedHierarchyIds)}
              />
            )}
          </LoadingSpinner>
        </div>
      </section>
    </HierarchyIdToaster>
  );
};

export default OverviewAssetSelection;
